import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import HorizontalLine from '../HorizontalLine/HorizontalLine';
import CustomerLogo from '../CustomerLogo/CustomerLogo';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { logoutUser, setSuccessMessage } from '../../actions/index';
import { axiosInstance } from '../../functions/axios';

import { Box, Button, Grid, ProgressTracker, Text, Typography } from '@blueprint/ui';

const StyledDiv = styled.div`
    padding-top: 100px;
    margin-left: 4.2vw;
    margin-right: 4.2vw;
    padding-bottom: 5em;
`;

const Registration2 = ({ location }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const REGISTER_USER_URL = process.env.REACT_APP_REGISTER_USER_URL;
    let allDetails = location.state === undefined ? null : location.state.allDetails;
    let newPwd = location.state === undefined ? null : location.state.newPassword;
    let cnfPwd = location.state === undefined ? null : location.state.confirmPassword;
    let saveDetails = location.state === undefined ? null : location.state.futureDetails;
    let autoPay = location.state === undefined ? null : location.state.autoPayCb;

    const [secDetails, setSecDetails] = useState({
        queOne: '',
        queTwo: '',
        queThree: '',
        ansOne: '',
        ansTwo: '',
        ansThree: '',
    });

    const logoutClicked = () => {
        dispatch(logoutUser());
    };

    const globalState = useSelector((state) => state);
    useEffect(() => {
        console.log('details are', location.state.allDetails, location.state.saveDetails, location.state.autoPay);
        setSecDetails({
            queOne: allDetails.queOne,
            queTwo: allDetails.queTwo,
            queThree: allDetails.queThree,
            ansOne: allDetails.ansOne,
            ansTwo: allDetails.ansTwo,
            ansThree: allDetails.ansThree,
        });
        if (!globalState.beneDetails.details.isLogged) {
            history.push('/login');
        }
    }, [globalState, history]);
    const footerHeight = globalState.beneDetails.footerHeight;

    const progressBarData = ['Setup', 'Verify'];

    const callSubmit = () => {
        // VALIDATE USER API CALL
        const validateUser = async () => {
            try {
                const response = await axiosInstance.post(
                    REGISTER_USER_URL,
                    JSON.stringify({
                        autoPay: autoPay,
                        confirmPassword: cnfPwd,
                        // emailId: globalState.beneDetails.details.emailId,
                        password: newPwd,
                        qa1: {
                            answer: secDetails.ansOne,
                            question: secDetails.queOne.label,
                        },
                        qa2: {
                            answer: secDetails.ansTwo,
                            question: secDetails.queTwo.label,
                        },
                        qa3: {
                            answer: secDetails.ansThree,
                            question: secDetails.queThree.label,
                        },
                    })
                );

                if (response.status === 200) {
                    let data = {
                        status: 200,
                        statusText: 'User has been registered successfully.',
                    };
                    try {
                        dispatch(setSuccessMessage(data));
                    } catch (e) {
                        console.error(`Logging store.dispatch(setSuccessMessage(data)) error`, e);
                    }
                    logoutClicked();
                }
            } catch (error) {
                console.log('it is coming here in error', error);
            }
        };
        validateUser();
    };

    return (
        <StyledDiv style={{ paddingBottom: `${footerHeight + 20}px` }} role='main'>
            <Grid container>
                <CustomerLogo />
                <Grid container>
                    <Box borderLeft='3px solid red' margin='0 0 2vw 0' paddingLeft='10px'>
                        <Typography variant='h1' className='page-title' tabIndex='-1'>
                            {t('registrationPageTwo.section_title')}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Box width='auto' marginTop={['15px', '15px', '15px', '15px']}>
                        <ProgressTracker activeIndex={1} data={progressBarData} />
                    </Box>
                </Grid>

                <Grid container>
                    <Grid container>
                        <Box marginTop={['15px', '15px', '15px', '15px']}>
                            <Typography variant='h2'>{t('registrationPageTwo.confirm_label')}</Typography>
                        </Box>
                    </Grid>

                    <div role='group' aria-labelledby='secAns1' style={{ width: '100%' }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box marginTop={['5px', '5px', '5px', '10px']}>
                                <Typography variant='body1' id='secAns1'>
                                    <b>{t('registrationPageTwo.sec_que_one')}</b>
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box marginLeft={['15px', '15px', '15px', '30px']}>
                                <Grid container>
                                    <Box marginTop={['5px', '5px', '5px', '8px']}>
                                        <Typography variant='body1' id='reg2-que1-label'>
                                            {t('registrationPageTwo.que')} : {secDetails.queOne.label}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid container>
                                    <Box marginTop={['5px', '5px', '5px', '8px']}>
                                        <Typography variant='body1' id='reg2-ans1-label'>
                                            {t('registrationPageTwo.ans')} : {secDetails.ansOne}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Box>
                        </Grid>
                    </div>

                    <div style={{ width: '100%' }}>
                        <HorizontalLine />
                    </div>

                    <div role='group' aria-labelledby='secAns2' style={{ width: '100%' }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box>
                                <Typography variant='body1' id='secAns2'>
                                    <b>{t('registrationPageTwo.sec_que_two')}</b>
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box marginLeft={['15px', '15px', '15px', '30px']}>
                                <Grid container>
                                    <Box marginTop={['5px', '5px', '5px', '8px']}>
                                        <Typography variant='body1' id='reg2-que2-label'>
                                            {t('registrationPageTwo.que')} : {secDetails.queTwo.label}
                                        </Typography>
                                    </Box>
                                </Grid>

                                <Grid container>
                                    <Box marginTop={['5px', '5px', '5px', '8px']}>
                                        <Typography variant='body1' id='reg2-ans2-label'>
                                            {t('registrationPageTwo.ans')} : {secDetails.ansTwo}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Box>
                        </Grid>
                    </div>

                    <div style={{ width: '100%' }}>
                        <HorizontalLine />
                    </div>

                    <div role='group' aria-labelledby='secAns3' style={{ width: '100%' }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box>
                                <Typography variant='body1' id='secAns3'>
                                    <b>{t('registrationPageTwo.sec_que_three')}</b>
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box marginLeft={['15px', '15px', '15px', '30px']}>
                                <Grid container>
                                    <Box marginTop={['5px', '5px', '5px', '8px']}>
                                        <Typography variant='body1' id='reg2-que3-label'>
                                            {t('registrationPageTwo.que')} : {secDetails.queThree.label}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid container>
                                    <Box marginTop={['5px', '5px', '5px', '8px']}>
                                        <Typography variant='body1' id='reg2-ans3-label'>
                                            {t('registrationPageTwo.ans')} : {secDetails.ansThree}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Box>
                        </Grid>
                    </div>

                    <div style={{ width: '100%' }}>
                        <HorizontalLine />
                    </div>
                    <Grid item xs={12} sm={7}>
                        <Box>
                            <Typography variant='body1'>{t('registrationPageTwo.final_label')}</Typography>
                        </Box>
                    </Grid>
                    <div style={{ width: '100%' }}>
                        <HorizontalLine />
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <Box marginTop={['5px', '5px', '5px', '24px']}>
                                <Button
                                    id='reg2-back-button'
                                    variant='light.tertiary'
                                    onClick={() => {
                                        history.push({
                                            pathname: '/registration1',
                                            state: {
                                                allDetails: secDetails,
                                                newPassword: newPwd,
                                                confirmPassword: cnfPwd,
                                                futureDetails: saveDetails,
                                                autoPayCb: autoPay,
                                                comingBack: true,
                                            },
                                        });
                                    }}
                                >
                                    {t('registrationPageTwo.back')}
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box marginTop={['5px', '5px', '5px', '24px']} style={{ float: 'right' }}>
                                <Button
                                    id='reg2-submit-button'
                                    variant='light.primary'
                                    onClick={() => {
                                        callSubmit();
                                    }}
                                >
                                    {t('registrationPageTwo.submit')}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </StyledDiv>
    );
};

export default Registration2;
